import React from 'react'
import Main from '../components/FestPage/Main'

const FestPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default FestPage